module.exports = __webpack_public_path__ + "static/img/ycre1920-1.76b52aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/home/banner/ycre1920-1.jpg
// module id = izuU
// module chunks = 50